var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "room-upgrade-banner component" }, [
    _c(
      "div",
      {
        staticClass: "room-upgrade-banner__wrapper",
        style: [
          {
            "background-image":
              "url(" +
              _vm.previousRoomUpgradeImage +
              "?wid=1280&hei=659&fmt=jpeg&op_usm=1,1,5,0&resMode=sharp2&fit=crop&qlt=75,0)",
          },
        ],
      },
      [
        _c("span", { staticClass: "room-upgrade-banner__flag" }, [
          _vm._v(
            _vm._s(
              _vm.tc("booking.onlyMorePerNight", {
                price: _vm.getDisplayPrice({
                  price: _vm.roomUpgradePriceDifference,
                  withIsoCode: true,
                  isoAfter: true,
                }),
              })
            )
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "room-upgrade-banner-content" }, [
          _c("div", { staticClass: "room-upgrade-banner__eyebrow" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("booking.aBetterRoomAwaitsYou")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "room-upgrade-banner__title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("booking.upgradeYourStay")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "room-upgrade-banner__ctas" },
            [
              _c("room-upgrade-modal", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var activate = ref.activate
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "see-details-cta",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return activate($event)
                              },
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.stopPropagation()
                                $event.preventDefault()
                                return activate($event)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.tc("booking.seeDetails")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "upgrade-cta",
                  class: {
                    loading: _vm.roomUpgradeLoading,
                    "upgrade-selected": _vm.roomUpgradeSelected,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleRoomUpgradeClick($event)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleRoomUpgradeClick($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.roomUpgradeSelected
                          ? _vm.tc("booking.removeUpgrade")
                          : _vm.tc("booking.upgrade")
                      ) +
                      "\n          "
                  ),
                  _c(
                    "div",
                    { staticClass: "sr-only", attrs: { role: "status" } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.roomUpgradeLoading
                              ? _vm.tc("accessibility.loadingButtonStatus")
                              : ""
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }